<template>
  <div id="home">
    <b-row :style="tituloRowBG" class="tituloPaginaRow">
      <h1 class="tituloPagina text-center tituloIntro">
        {{ tituloPagina }}
      </h1>
    </b-row>
    <b-row class="p-3 p-sm-0 p-md-0 p-lg-0 p-xl-0">
      <!-- Busca de Diarios -->
      <b-col cols="12" sm="12" md="12" lg="5" xl="5" id="colunaLogin">
        <h4 class="text-center">{{ tituloBusca }}</h4>
        <b-row>
          <b-form
            id="formBusca"
            @submit="onSubmitBusca"
            @reset="onResetBusca"
            class="mb-4 mb-sm-0 mb-md-0 mb-lg-0 mb-xl-0"
          >
            <p v-if="client === 'DOE-AL'">
              Realize sua busca, utilizando o critério desejado. Para isso,
              preencha qualquer um dos campos abaixo.
            </p>
            <p v-else>
              Busque nas edições publicadas usando o critério desejado
              preenchendo qualquer um dos campos abaixo.
            </p>
            <b-row>
              <b-col cols="12">
                <b-form-group id="inputGrupoPalavraChave">
                  <b-form-input
                    id="inputPalavraChave"
                    type="text"
                    v-model="formBusca.palavra_chave"
                    placeholder="Buscar por: (Qualquer palavra...)"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  id="inputGrupoPeriodoInicial"
                  label="Período inicial:"
                  label-for="inputPeriodoInicial"
                >
                  <b-form-input
                    id="inputPeriodoInicial"
                    type="date"
                    v-model="formBusca.periodo_inicial"
                    placeholder="Período inicial ..."
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  id="inputGrupoPeriodoFinal"
                  label="Período final:"
                  label-for="inputPeriodoFinal"
                >
                  <b-form-input
                    id="inputPeriodoFinal"
                    type="date"
                    v-model="formBusca.periodo_final"
                    placeholder="Período final ..."
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  id="inputGrupoNumeroEdicao"
                  label="Número da Edição:"
                  label-for="inputNumeroEdicao"
                >
                  <b-form-input
                    id="inputNumeroEdicao"
                    type="text"
                    v-model="formBusca.edition_number"
                    placeholder="Número da Edição ..."
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <!-- Select Tipo de busca -->
              <b-col>
                <b-form-group
                  id="selectGrupoBuscaTipo"
                  label="Buscar por:"
                  label-for="selectBuscaTipo"
                >
                  <v-select
                    id="selectBuscaTipo"
                    placeholder="Selecione o tipo da busca"
                    label="title"
                    v-model="formBusca.searchType"
                    :options="searchTypeOptions"
                  >
                  </v-select>
                </b-form-group>
              </b-col>
              <!-- Select Ordem -->
              <b-col>
                <b-form-group
                  id="selectGrupoOrdenacao"
                  label="Ordenar por:"
                  label-for="selectOrdenacao"
                >
                  <v-select
                    id="selectOrdenacao"
                    placeholder="Selecione a ordenação da busca"
                    label="title"
                    v-model="formBusca.order"
                    :options="orderOptions"
                  >
                  </v-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group class="float-right">
                  <b-button type="reset" variant="cinzaClaro">Limpar</b-button>
                  <b-button type="submit" variant="primary">Buscar</b-button>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-row>
      </b-col>
      <!-- Tabela Publicacoes -->
      <b-col
        cols="12"
        sm="12"
        md="12"
        lg="6"
        xl="6"
        class="mb-sm-6"
        offset-lg="1"
        offset-xl="1"
        id="colunaPublicacoes"
      >
        <h4 class="text-center">Publicações</h4>
        <b-row>
          <b-table
            striped
            hover
            :items="items"
            :fields="fields"
            :per-page="perPage"
          >
            <template v-slot:cell(number)="data">
              <span class="editionName"
                >{{ data.item['edition_type_name'] }} {{ data.item['number'] }}
                {{ data.item['suplement'] | formatSuplement }}</span
              >
              <br />
              <span class="downloads"
                ><icon name="download"></icon>
                {{ data.item['downloads'] }} downloads</span
              >
            </template>
            <template v-slot:cell(publication_date)="data">
              {{ data.item['publication_date'] | formatDate }}
            </template>
            <template v-slot:cell(acoes)="data">
              <a
                :href="viewEdition(data.item.id)"
                target="_blank"
                v-b-tooltip.hover
                title="Ver Edição"
              >
                <icon name="eye"></icon>
              </a>
              <a
                :href="downloadEdition(data.item.id)"
                v-b-tooltip.hover
                title="Baixar edição"
              >
                <icon name="download"></icon>
              </a>
            </template>
          </b-table>
        </b-row>
        <b-row>
          <b-col cols="12" class="text-right">
            <router-link to="/edicoes">Ver edições anteriores</router-link>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  import 'moment/locale/pt-br'
  import vSelect from 'vue-select'

  import PortalApi from '@/api/portal'
  import client from '@/main.js'
  export default {
    components: {
      vSelect
    },
    data() {
      return {
        client: null,
        perPage: 5,
        tituloPagina: '',
        tituloBusca: 'Pesquisar Edições',
        tituloRowBG: '',
        searchTypeOptions: [
          { title: 'Todas as palavras', value: 'toda_palavra' },
          { title: 'Frase exata', value: 'frase_exata' },
          { title: 'Qualquer palavra', value: 'qualquer_palavra' }
        ],
        orderOptions: [
          { title: 'Mais antiga', value: 'antigo' },
          { title: 'Mais nova', value: 'novo' },
          { title: 'Por relevância', value: 'relevancia' }
        ],
        formBusca: {
          palavra_chave: '',
          periodo_inicial: '',
          periodo_final: '',
          edition_number: '',
          searchType: {
            title: 'Frase exata',
            value: 'frase_exata'
          },
          order: {
            title: 'Mais nova',
            value: 'novo'
          }
        },
        fields: [
          {
            key: 'number',
            label: 'Edição',
            sortable: false,
            class: 'number'
          },
          {
            key: 'publication_date',
            label: 'Data da publicação',
            sortable: false,
            class: 'date'
          },
          {
            key: 'acoes',
            label: 'Ações',
            class: 'text-center actions'
          }
        ],
        items: []
      }
    },
    created() {
      let me = this
      me.fetchEditions()
      me.client = client.CLIENT
      me.tituloPagina = client.clientData.home.title
      me.tituloRowBG = {
        backgroundImage:
          'url(' +
          require('@/assets/imagens/' + me.client + '/tituloPagFdo.png') +
          ')'
      }
    },
    methods: {
      fetchEditions(page = 1) {
        let me = this
        const promisse = PortalApi.fetchEditions(page)
        promisse.then((items) => {
          me.items = items.editions
        })
      },
      viewEdition(editionId) {
        return axios.defaults.baseURL + '/editions/viewPdf/' + editionId
      },
      downloadEdition(editionId) {
        return axios.defaults.baseURL + '/editions/downloadPdf/' + editionId
      },
      onSubmitBusca(evt) {
        let me = this
        evt.preventDefault()
        me.$store.commit('populateSearch', me.formBusca)
        me.$router.push('/busca')
      },
      onResetBusca(evt) {
        evt.preventDefault()
        /* Limpar os campos do formulario */
        this.formBusca.palavra_chave = ''
        this.formBusca.periodo_inicial = ''
        this.formBusca.periodo_final = ''
        this.formBusca.edition_number = ''
        /* Trick to reset/clear native browser form validation state */
        this.showBusca = false
        this.$nextTick(() => {
          this.showBusca = true
        })
      }
    },
    filters: {
      formatDate: function (value) {
        if (value) {
          return moment.utc(String(value)).format('LL')
        }
        return '-'
      },
      formatSuplement: function (value) {
        if (value === 1 || value === '1') {
          return ' - Suplemento'
        }
        return ''
      }
    }
  }
</script>

<style lang="scss">
  @import '../assets/scss/estilos.scss';
  #home {
    h4 {
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 1.2rem;
    }
    a {
      font-size: 14px;
      font-weight: 500;
      font-style: italic;
    }
    #colunaSobre {
      p {
        font-size: 14px;
        font-style: normal;
      }
      ul {
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
        font-style: none;
      }
    }

    table {
      font-size: 14px;
      font-weight: 300;
      a {
        margin-right: 10px;
        color: #000;
        &:last-child {
          margin-right: 0;
        }
        &:hover {
          color: $corPrimariaClara;
        }
      }
      thead {
        th {
          border-bottom: 2px solid $corPrimaria;
          border-top: none;
          &.date {
            min-width: 160px;
          }
          &.actions {
            min-width: 85px;
          }
        }
      }
      tbody {
        td {
          border-right: 1px solid #ddd;
          line-height: 1;
          &:last-child {
            border-right: none;
          }
          &.number {
            line-height: 18px;
          }
          .editionName {
            line-height: 1;
          }
          .downloads {
            color: #8e8e8e;
            font-weight: 500;
            font-size: 0.75rem;
            .fa-icon {
              height: 12px;
              margin-bottom: 4px;
            }
          }
        }
      }
    }
  }
  .v-select {
    .dropdown-toggle {
      white-space: nowrap !important;
    }
  }
  .tituloIntro {
    margin: auto;
  }
  .diarioBusca {
    margin-top: 15px;
    margin-right: 15px;
  }
  /* xs */
  @media (max-width: 355px) {
    #home {
      table {
        // font-size: 12px;
        th,
        td {
          padding: 0.25rem;
        }
        thead {
          th.date {
            min-width: 100px;
          }
        }
        a {
          margin-right: 2px;
          svg {
            width: 14px !important;
            height: 14px !important;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue